import PropTypes from 'prop-types';
import React from 'react';

import { BANNER_HEIGHT } from 'components/Banner';
import { extraLarge } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const TopNavigationBanner = ({ backgroundColor, children }) => (
  <div className="TopNavigationBanner">
    <div className="TopNavigationBanner__Message">{children}</div>

    <style jsx>{`
      .TopNavigationBanner {
        background-color: ${backgroundColor};
        width: 100%;
        transition: transform 0.2s ease-out;
        position: relative;
        min-height: ${BANNER_HEIGHT}px;
        padding: 0;
      }

      .TopNavigationBanner__Message {
        max-width: 100%;
        position: relative;
        margin: 0 auto;
      }

      @media ${extraLarge} {
        .TopNavigationBanner {
          padding: 0 ${Theme.get('spacing') * 4}px;
        }

        .TopNavigationBanner__Message {
          max-width: 66%;
        }
      }
    `}</style>
  </div>
);

TopNavigationBanner.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
};

TopNavigationBanner.defaultProps = {
  backgroundColor: Theme.get('colors-white'),
  children: null,
};

export default TopNavigationBanner;
